// extracted by mini-css-extract-plugin
export var container = "_dv-0";
export var infoIcon = "_dv-2";
export var internalLabel = "_dv-3";
export var titleRowCol = "_dv-1";